import { render, staticRenderFns } from "./UploadControl.vue?vue&type=template&id=cc3cabd2&"
import script from "./UploadControl.vue?vue&type=script&lang=js&"
export * from "./UploadControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports